__turbopack_context__.v({
  "borderTop": "C3Dpla_borderTop",
  "borderTopNone": "C3Dpla_borderTopNone",
  "container": "C3Dpla_container",
  "desktopMainLink": "C3Dpla_desktopMainLink",
  "desktopSubMenuBtn": "C3Dpla_desktopSubMenuBtn",
  "enLangButtonStyles": "C3Dpla_enLangButtonStyles",
  "hamMenuWrapper": "C3Dpla_hamMenuWrapper",
  "logoContainer": "C3Dpla_logoContainer",
  "logoContainerTitle": "C3Dpla_logoContainerTitle",
  "logoContainerVerticalLine": "C3Dpla_logoContainerVerticalLine",
  "mainMenuBtn": "C3Dpla_mainMenuBtn",
  "menuContainer": "C3Dpla_menuContainer",
  "mobileMainMenuBtn": "C3Dpla_mobileMainMenuBtn",
  "mobileSubMenuBtn": "C3Dpla_mobileSubMenuBtn",
  "mobileSubMenuBtnTitle": "C3Dpla_mobileSubMenuBtnTitle",
  "mobileSubMenuContainer": "C3Dpla_mobileSubMenuContainer",
  "rightArrowTitlSubStyles": "C3Dpla_rightArrowTitlSubStyles",
  "searchBtn": "C3Dpla_searchBtn",
  "secondContainerBg": "C3Dpla_secondContainerBg",
  "secondLogoContainerVerticalLine": "C3Dpla_secondLogoContainerVerticalLine",
  "subMenuContainer": "C3Dpla_subMenuContainer",
});
